import React from "react";
import { useEffect } from "react";
import { Router, redirect, useNavigate } from "react-router-dom";

function Success() {

    let navigate = useNavigate();
    useEffect(() => {
        setTimeout(() => {
            navigate('/')
        }, 5000);
    }, [])

    return (
        <div className="abstract">
            <h2 className="compTitle">Registration form submitted successfully!</h2>
            <p style={{textAlign: 'center'}}>You will hear from us soon, keep an eye on your registered email</p>
            <br/><br/>
            <p style={{textAlign: 'center'}}>Redirecting back to Home</p>
        </div>
    )
}

export default Success;